import { tagRoutes } from './tags.routes'
import { authRoutes } from './auth.routes'
import { bookingRoutes } from './bookings.routes'
import { areaRoutes } from './areas.routes'
import { categoryRoutes } from './categories.routes'
import { couponRoutes } from './coupons.routes'
import { floormapRoutes } from './floormap.routes'
import { payoutRoutes } from './payouts.routes'
import { productRoutes } from './products.routes'
import { profileRoutes } from './profile.routes'
import { salesRoutes } from './sales.routes'
import { areaTypeRoutes } from './areaTypes.routes'
import { rentalRoutes } from './rentals.routes'
import { userRoutes } from './users.routes'
import { settingRoutes } from './settings.routes'
import { dashboardRoutes } from './dashboard.routes'
import { openingHourRoutes } from './openingHours.routes'
import { fabricRoutes } from './fabrics.routes'
import { conditionRoutes } from './conditions.routes'
import { genderRoutes } from './genders.routes'
import { typeRoutes } from './types.routes'

export const routes = {
	...authRoutes,
	...dashboardRoutes,
	...salesRoutes,
	...productRoutes,
	...bookingRoutes,
	...payoutRoutes,
	...profileRoutes,
	...areaRoutes,
	...floormapRoutes,
	...categoryRoutes,
	...couponRoutes,
	...tagRoutes,
	...areaTypeRoutes,
	...rentalRoutes,
	...userRoutes,
	...settingRoutes,
	...openingHourRoutes,
	...fabricRoutes,
	...conditionRoutes,
	...genderRoutes,
	...typeRoutes
}
